
import SliderVertical1 from "../../../assets/outline/SliderVertical1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SliderVertical1Icon({ className, dataTestid = "SliderVertical1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SliderVertical1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
